module.exports = __webpack_public_path__ + "static/media/15.db33d2da.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/悬浮窗/15.png
// module id = 1305
// module chunks = 0